<template>
  <div>
    <p class="text-bold">{{ $t('Providers') }}:</p>
    <b-table :items="providers" :fields="fields" striped bordered outlined v-bind:busy="loading" small >
      <template #cell(name)="data">
        <b-link :to="{name: 'provider', params: {id: data.item.providerId}}">
          {{ data.value }}
        </b-link>
      </template>

      <template #cell(commission)="data">
        {{ formatPrice(data.value) }}
      </template>

      <template #cell(commissionPercent)="data">
        {{ data.value }}%
      </template>

      <template #cell(price)="data">
        {{ formatPrice(data.value) }}
      </template>

      <template #cell(requestTime)="data">
        {{ data.value | moment("HH:mm DD/MM/YYYY") }}
      </template>

      <template #cell(serviceTime)="data">
        {{ data.value | moment("HH:mm DD/MM/YYYY") }}
      </template>
      <template #cell(actions)="data">
        <b-button size="sm" variant="link" class="mb-2" pill @click="()=>showProvider(data.item.id)">
          <i class="fa-solid fa-pen"></i>
        </b-button>
<!--        <b-button size="sm" variant="link" class="mb-2" pill @click="()=>copyText(data.item.id)">
          <i class="fa-solid fa-copy"></i>
        </b-button>-->
      </template>

      <template #cell(status)="data">
        <b-badge :variant="statusClass(data.value)">
          <i :class="statusIcon(data.value)"></i> {{ data.value }}
        </b-badge>
      </template>
    </b-table>
    <div class="text-center">
      <b-button size="sm"
        variant="primary"
        class="mb-2" pill
        @click="()=>showProvider()">
        <i class="fa-solid fa-plus"></i>
      </b-button>
    </div>
    <provider-services-modal ref="addRequestModal" :systemId="featureId"
                             :systemName="SYSTEM_ID" @refresh="refresh"/>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import ProviderServicesModal from "@/components/modals/providers/ProviderServicesModal.vue";

const SYSTEM_ID = "GUEST_FEATURE";


export default {
  name: "GuestFeatureRequestedProviderTable",
  components: {ProviderServicesModal},
  props: {
    featureId: {
      type: String,
      required: true
    },
    featurePrice:{
      required: false
    },
    checkInDate: {
      type: String,
      required: false
    },
    contractId: {
      type: String,
      required: false
    }
  },
  data: () => ({
    SYSTEM_ID: SYSTEM_ID,
    loading: true,
    providers: [],
  }),
  watch: {
    featureId: {
      immediate: true,
      handler() {
        this.refresh();
      }
    }
  },
  computed: {
    statusVariants() {
      return {"PENDING": "warning", "COMPLETED": "success", "CANCELLED": "warning",};
    },
    statusClass() {
      return (status) => {
        return this.statusVariants[status] || 'secondary';
      }
    },
    statusIcon() {
      return (status) => {
        return `icon-${status.toLowerCase()}`;
      }
    },
    fields() {
      return [
        {key: 'serviceTime', label: this.$t('Service Time')},
        {key: 'name', label: this.$t('Name')},
        // {key: 'commission', label: this.$t('Commission')},
        // {key: 'commissionPercent', label: this.$t('Commission Percent')},
        {key: 'price', label: this.$t('Price')},
        {key: 'amount', label: this.$t('Amount')},
        // {key: 'requestTime', label: this.$t('Request Time')},
        // {key: 'note', label: this.$t('Note')},
        // {key: 'status', label: this.$t('Status')},
        // {key: 'paid', label: this.$t('Paid')}
        {key: 'actions', label: ""}
      ]
    },
    totalPriceAndCommission() {
      return (this.providers || []).reduce((acc, provider) => {
        if (provider.price && provider.amount) {
          acc += provider.price * provider.amount;
        }
        if (provider.commission) {
          acc += provider.commission;
        }
        return acc;
      }, 0);
    }
  },
  methods: {
    ...mapActions('providersServices', ['fetchProviderServicesBySystemId']),
    refresh() {
      let $this = this;
      this.loading = true;
      this.fetchProviderServicesBySystemId({systemName: SYSTEM_ID, id: this.featureId}).then(providers => {
        $this.providers = providers;
      }).finally(() => {
        $this.loading = false;
      });
    },
    formatPrice(value) {
      return new Intl.NumberFormat('ge-AU', {style: 'currency', currency: 'EUR'}).format(value);
    },
    showProvider(providerId){
      this.$refs.addRequestModal.show(providerId, this.contractId, this.featurePrice - this.totalPriceAndCommission, this.checkInDate);
    }
  }
}
</script>


<style scoped>

</style>